import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Switch } from "@/components/ui/switch";

export default function SanctuarySettingsFields({
  monthlyCareCost, setMonthlyCareCost,
  sponsorLink, setSponsorLink,
  sanctuaryStory, setSanctuaryStory,
  arrivalDate, setArrivalDate,
  isSponsored, setIsSponsored,
}) {
  return (
    <div className="space-y-4 pt-3 border-t border-amtm-border/60">
      <p className="text-xs font-semibold uppercase tracking-wide text-amtm-teal">Sanctuary Details</p>

      <div>
        <Label htmlFor="arrival-at-sanctuary-date">Arrival at Sanctuary Date</Label>
        <Input
          id="arrival-at-sanctuary-date"
          type="date"
          value={arrivalDate}
          onChange={(e) => setArrivalDate(e.target.value)}
          data-testid="arrival-at-sanctuary-date-input"
          className="mt-1.5 h-11"
        />
      </div>

      <div>
        <Label htmlFor="monthly-care-cost">Monthly Care Cost (₹)</Label>
        <Input
          id="monthly-care-cost"
          type="number"
          min="0"
          value={monthlyCareCost}
          onChange={(e) => setMonthlyCareCost(e.target.value)}
          data-testid="monthly-care-cost-input"
          className="mt-1.5 h-11"
        />
      </div>

      <div>
        <Label htmlFor="sponsor-razorpay-link">Sponsor Razorpay Link</Label>
        <Input
          id="sponsor-razorpay-link"
          value={sponsorLink}
          onChange={(e) => setSponsorLink(e.target.value)}
          placeholder="https://razorpay.me/@amtmindia"
          data-testid="sponsor-razorpay-link-input"
          className="mt-1.5 h-11"
        />
      </div>

      <div>
        <Label htmlFor="sanctuary-story">Sanctuary Story</Label>
        <Textarea
          id="sanctuary-story"
          value={sanctuaryStory}
          onChange={(e) => setSanctuaryStory(e.target.value)}
          placeholder="Their life at the sanctuary. Leave blank to use Public Story / case history instead."
          data-testid="sanctuary-story-input"
          className="mt-1.5 min-h-[80px]"
        />
      </div>

      <div className="flex items-center justify-between py-1">
        <div>
          <Label htmlFor="is-sponsored-toggle">Sponsored</Label>
          <p className="text-xs text-amtm-textMuted mt-0.5">Shows a "Sponsored ❤" badge on the public Sanctuary page once someone has taken up sponsorship.</p>
        </div>
        <Switch id="is-sponsored-toggle" checked={!!isSponsored} onCheckedChange={setIsSponsored} data-testid="is-sponsored-toggle" />
      </div>
    </div>
  );
}
